import { useEffect, useState } from 'react';
import {
    Grid,
    Icon,
    PargodaRoundButton,
    Typography,
    TextField,
    Button,
    IconButton,
    useTheme,
    useAppDispatch,
    Stack,
} from '../../../base';
import {
    CardWrapper,
    ContentWrapper,
    CommentDate,
    CommentItem,
    ScrollableComments,
} from './CommentBox.styles';
import { useTranslation } from 'react-i18next';
import {
    convertIsoDateToDDMMYY,
    IJobApplicationComment,
} from '../../../common';
import { jobApplicationActions } from '../../../actions';

interface Props {
    comments: Array<IJobApplicationComment>;
    displayComments?: boolean;
    withCard?: boolean;
    onSave?: () => void;
    isDisabled?: boolean;
    rows?: number;
}
const CommentBox = (props: Props) => {
    const { comments, displayComments = true, withCard = true, onSave, isDisabled = false, rows = 3 } = props;
    const theme = useTheme();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const [newComment, setNewComment] = useState('');
    const [editingCommentId, setEditingCommentId] = useState<number | null>(
        null
    );
    const [isEditing, setIsEditing] = useState(false);

    const handleAddComment = () => {
        if (newComment.trim()) {
            dispatch(
                jobApplicationActions.createJobApplicationComment({
                    text: newComment.trim(),
                })
            );
        }
    };

    useEffect(() => {
        if (comments.find((comment) => comment.text === newComment.trim())) {
            setNewComment('');
        }
    }, [comments]);

    const handleEditComment = (id: number) => {
        const commentToEdit = comments.find((comment) => comment.id === id);
        if (commentToEdit) {
            setNewComment(commentToEdit.text);
            setEditingCommentId(id);
            setIsEditing(true);
        }
    };

    const handleCancelEdit = () => {
        setNewComment('');
        setEditingCommentId(null);
        setIsEditing(false);
    };

    const handleSaveEdit = () => {
        if (editingCommentId !== null) {
            // setComments(
            //     comments.map((comment) =>
            //         comment.id === editingCommentId
            //             ? { ...comment, text: newComment.trim() }
            //             : comment
            //     )
            // );
            setNewComment('');
            setEditingCommentId(null);
            setIsEditing(false);
        } else {
            handleAddComment();
        }

        if (onSave) {
            onSave();
        }
    };

    const Wrapper = withCard ? CardWrapper : ContentWrapper;

    return (
        <Wrapper>
            <Grid container direction="column" style={{ height: '100%' }}>
                {displayComments && (
                    <>
                        <Grid item>
                            <Typography variant="h6">
                                {t('jobApplicationPage.commentsTitle')}
                            </Typography>
                        </Grid>
                        <Grid item>
                            <Typography
                                variant="subtitle2"
                                color="textSecondary"
                            >
                                {t('jobApplicationPage.reasonForChange')}
                            </Typography>
                        </Grid>

                        <Grid item xs>
                            <ScrollableComments>
                                {comments?.map((comment) => (
                                    <CommentItem key={comment.id}>
                                        <Stack
                                            direction="row"
                                            spacing={1}
                                            gap={2}
                                        >
                                            <CommentDate variant="body2">
                                                {convertIsoDateToDDMMYY(
                                                    comment.date
                                                )}
                                            </CommentDate>
                                            <Typography
                                                variant="body2"
                                                color={
                                                    theme.palette.common.black
                                                }
                                            >
                                                {comment.text}
                                            </Typography>
                                            {/* <IconButton
                                            onClick={() =>
                                                handleEditComment(comment.id)
                                            }
                                            size="small"
                                        >
                                            <Icon name={'EditIcon'} />
                                        </IconButton> */}
                                        </Stack>
                                    </CommentItem>
                                ))}
                            </ScrollableComments>
                        </Grid>
                    </>
                )}
                <Grid item>
                    <TextField
                        fullWidth
                        multiline
                        rows={rows}
                        placeholder={
                            editingCommentId
                                ? t('jobApplicationPage.editComment')
                                : t('jobApplicationPage.addComment')
                        }
                        value={newComment}
                        onChange={(e) => setNewComment(e.target.value)}
                        variant="outlined"
                        disabled={isDisabled}
                        sx={{ paddingTop: theme.spacing(1) }}
                    />
                </Grid>
                <Grid item sx={{ textAlign: 'end', paddingTop: '24px' }}>
                    {isEditing && (
                        <Button
                            variant="contained"
                            onClick={handleCancelEdit}
                            sx={{ marginInlineEnd: theme.spacing(1) }}
                        >
                            {t('jobApplicationPage.cancelButtonLabel')}
                        </Button>
                    )}
                    <PargodaRoundButton
                        variant="outlined"
                        onClick={handleSaveEdit}
                        disabled={isDisabled || !newComment.trim()}
                        buttonColor={theme.palette.secondary.main}
                    >
                        {isEditing
                            ? t('jobApplicationPage.saveEditCommentButtonLabel')
                            : t('jobApplicationPage.saveCommentButtonLabel')}
                    </PargodaRoundButton>
                </Grid>
            </Grid>
        </Wrapper>
    );
};

export default CommentBox;
